import Header from './Header';
import { Typography } from '@mui/material';
import { gray100 } from '../../constants/Colors';
import { spHeaderHeight, headerHeight } from '../../constants/Location';

const styles = {
  container: {
    '@media screen and (max-width:600px)': {
      height: `calc( 100vh - ${spHeaderHeight} - 64px)`,
      m: `${spHeaderHeight} auto 0`,
      pt: '64px',
      width: '90%'
    },
    height: `calc( 100vh - ${headerHeight} - 96px )`,
    m: `${headerHeight} auto 0`,
    pt: '96px',
    width: '560px'
  },
  text: {
    fontSize: '18px',
    color: gray100,
    mt: '24px',
    textAlign: 'center'
  },
  textDesctiprion: {
    fontSize: '16px',
    color: gray100,
    mt: '24px',
    textAlign: 'center'
  },
  title: {
    color: gray100,
    fontSize: '24px',
    fontWeight: '500',
    mt: '16px',
    textAlign: 'center'
  }
};

const NotFound = (): JSX.Element => {
  return (
    <>
      <Header />
      <Typography component="div" sx={styles.container}>
        <Typography sx={styles.title}>404 Not Found</Typography>
        <Typography sx={styles.text}>
          お探しのページは見つかりませんでした
        </Typography>
        <Typography sx={styles.textDesctiprion}>
          アクセスしようとしたページは削除されたかURLが変更されているため
          <br />
          見つけることができません。
        </Typography>
      </Typography>
    </>
  );
};

export default NotFound;
